import React from 'react';
import './Form.css';

class Form extends React.Component {
    state = {
        start: '',
        end: '',
        number: this.props.nodecount + 1,
        distance: '',
        startPoint: '',
        endPoint: ''
    };

    onFormSubmit = (e) => {
        if(this.props.nodecount > 0) {
            this.props.addNewArc([this.state.start, this.state.end], this.state.distance);
            this.setState({start: '', end: '', distance: ''});
        }
    };

    onStartChange = (e) => {
        const start = parseInt(e.target.value);
        if(!isNaN(start)) {
            this.setState({start});
        }
    };

    onEndChange = (e) => {
        const end = parseInt(e.target.value);
        if(!isNaN(end)) {
            this.setState({end});
        }
    };

    onNumberChange = (e) => {
        const number = parseInt(e.target.value);
        if(number > this.props.nodecount && number < 100) {
            this.setState({number});
        }
    };

    onGenerateSubmit = (e) => {
        this.props.generateNodes(this.state.number);
        this.setState({number: this.state.number+1});
    };

    onDistanceChange = (e) => {
        const distance = e.target.value;
        this.setState({distance});
    };

    onStartNodeChange = (e) => {
        const startPoint = e.target.value;
        if(startPoint > 0 && startPoint <= this.props.nodecount) {
            this.setState({startPoint});
        }
    }

    onEndNodeChange = (e) => {
        const endPoint = e.target.value;
        if(endPoint > 0 && endPoint <= this.props.nodecount) {
            this.setState({endPoint});
        }
    }

    onStartEndNodesChange = (e) => {
        this.props.changeStartEnd(this.state.startPoint, this.state.endPoint);
    }

    findPath = (e) => {
        this.props.algorithme();
    }

    render() {
        return (
            <div className="form container">
            {this.props.nodecount > 0 &&                 
                <div className="pathOptions">
                    <input 
                        className="startPoint"
                        type="number" 
                        placeholder="Start Point" 
                        value={this.state.startPoint}
                        onChange={this.onStartNodeChange}
                    />
                    <input 
                        className="endPoint"
                        type="number" 
                        placeholder="End Point"
                        onChange={this.onEndNodeChange}
                        value={this.state.endPoint}
                    />

                    <button onClick={this.onStartEndNodesChange}>Define</button>
                </div>

            }
                <input 
                    type="number"
                    placeholder="Nodes"
                    value={this.state.number}
                    onChange={this.onNumberChange}
                />
                <button 
                    onClick={this.onGenerateSubmit}
                    style={{backgroundColor: this.props.nodecount > 0 ? 'rgb(160, 40, 76)' : 'rgb(34, 12, 107)'}}
                >
                    {this.props.nodecount > 0 ? 'Re-Generate' : 'Generate'}
                </button>

                <button 
                    className="run"
                    onClick={this.findPath}  
                >RUN</button>
            </div>
        );
    }
}

export default Form;